import instance from "../axios/axios";


// auth methods
export const authenticateUser = async (body) => {
  try {
    const response = await instance.post(`/api/user/login`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};

export const refreshUserToken = async (token) => {
  try {
    const response = await instance.post(`/api/user/refresh-token`, {token});
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
}


export const fetchUsers = async ({
  page,
  limit,
  search
}) => {
  try {
    const response = await instance.get(`/api/user/users?page=${page}&limit=${limit}&search=${search}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
}

export const createUser = async (body) => {
  try {
    const response = await instance.post(`/api/user/adduser`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUser = async (id, body) => {
  try {
    const response = await instance.put(`/api/user/update/${id}`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};


export const deleteUser = async (id) => {
  try {
    const response = await instance.delete(`/api/user/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};


export const getHistoryLogsByEntity = async (entityType, entityId, extras) => {
  try {
    const response = await instance.get(`/api/history/entity`, {
      params: {
        entityType,
        entityId,
        ...extras
      }
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
}


export const getAllHistoryLogs = async (params) => {
  try {
    const response = await instance.get(`/api/history/logs`, {
      params
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
}